module.exports = __webpack_public_path__ + "static/media/image6.c5388bf9.jpg";